const table = {
  columnList: 'Spaltenliste',
  noResults: 'Keine Ergebnisse gefunden',
  noResultsSubHeader: 'Wir können keinen Artikel finden, der Ihrer Suche entspricht',
};

export default table;
